import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { getConfig } from '~/web-frontend-core/config';
import Cookie from 'js-cookie';
export default class ImprintHash {
    constructor() {
        this.getImprintHash = () => {
            return this.imprintHash;
        };
        this.imprint = () => !getConfig('IS_SERVER') && new Promise(resolve => {
            const fpPromise = FingerprintJS.load();
            fpPromise.then(fp => fp.get()).then(result => {
                Cookie.set('imprint', result.visitorId, { secure: true, sameSite: 'lax' });
                resolve(this.imprintHash = result.visitorId);
            });
        });
    }
    static getInstance() {
        if (this.instance) {
            return this.instance;
        }
        this.instance = new ImprintHash();
        return this.instance;
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/utils/getImprintHash.js